<template>
  <div class="vehicles-table">
    <app-table-dropdown
      route="/vehicles/item/"
      :isHeaderLink="false"
      :response="list || []"
      :isAllClose="isAllClose"
    >
      <template #header>
        <div class="app-table-dropdown__table-header">
          <span
            class="app-table-dropdown__table-header-title app-table-dropdown__table-sort"
            @click="
              $emit(
                'changeSort',
                changeSort('model', sort.order, sort.field === 'model')
              )
            "
          >
            Марка авто

            <div
              v-if="sort.field === 'model'"
              :class="{
                'app-table-dropdown__table-sort-up': sort.order === 'desc',
                'app-table-dropdown__table-sort-down': sort.order === 'asc',
              }"
            ></div>
            <div v-else class="app-table-dropdown__table-sort-not-active"></div>
          </span>
          <span
            class="app-table-dropdown__table-header-title app-table-dropdown__table-sort"
            @click="
              $emit(
                'changeSort',
                changeSort('number', sort.order, sort.field === 'number')
              )
            "
          >
            Гос. номер
            <div
              v-if="sort.field === 'number'"
              :class="{
                'app-table-dropdown__table-sort-up': sort.order === 'desc',
                'app-table-dropdown__table-sort-down': sort.order === 'asc',
              }"
            ></div>
            <div v-else class="app-table-dropdown__table-sort-not-active"></div>
          </span>
          <span
            v-if="!responsive.isMd"
            class="app-table-dropdown__table-header-title"
          ></span>
          <span
            v-if="!responsive.isMd"
            class="app-table-dropdown__table-header-title"
          ></span>
        </div>
      </template>

      <template #row-header="{ item }">
        <div class="app-table-dropdown__row-header-default">
          <div class="app-table-dropdown__row-header-default-item">
            {{ item.model }}
          </div>
          <div
            class="app-table-dropdown__row-header-default-item app-table-dropdown__light"
          >
            {{ item.number }}
          </div>
          <div
            v-if="!responsive.isMd"
            class="app-table-dropdown__row-header-default-item"
          ></div>
          <div
            v-if="!responsive.isMd"
            class="app-table-dropdown__row-header-default-item"
          ></div>
        </div>
      </template>

      <template #row-body="{ item }">
        <div
          class="app-table-dropdown__row-body-default app-table-dropdown__container"
        >
          <div class="vehicles-table__row-body-content">
            <ul
              class="app-table-dropdown__list app-table-dropdown__row-body-default-item"
            >
              <li class="app-table-dropdown__list-item">
                <span
                  class="app-table-dropdown__list-title app-table-dropdown__list-row"
                >
                  Полный объем, л
                </span>
                <p
                  class="app-table-dropdown__list-text app-table-dropdown__list-row"
                >
                  {{ getAllVolume(item.sections) }}
                </p>
              </li>
              <li class="app-table-dropdown__list-item">
                <span
                  class="app-table-dropdown__list-title app-table-dropdown__list-row"
                >
                  Кол-во секций
                </span>
                <p
                  class="app-table-dropdown__list-text app-table-dropdown__list-row"
                >
                  {{ item.sections.length }}
                </p>
              </li>
            </ul>
            <ul
              class="app-table-dropdown__list app-table-dropdown__row-body-default-item"
            >
              <template v-if="item.trailerModel || item.trailerNumber">
                <li class="app-table-dropdown__list-item">
                  <span
                    class="app-table-dropdown__list-title app-table-dropdown__list-row"
                  >
                    Модель прицепа
                  </span>
                  <p
                    class="app-table-dropdown__list-text app-table-dropdown__list-row"
                  >
                    {{ item.trailerModel || 'н/д' }}
                  </p>
                </li>
                <li class="app-table-dropdown__list-item">
                  <span
                    class="app-table-dropdown__list-title app-table-dropdown__list-row"
                  >
                    Номер прицепа
                  </span>
                  <p
                    class="app-table-dropdown__list-text app-table-dropdown__list-row"
                  >
                    {{ item.trailerNumber || 'н/д' }}
                  </p>
                </li>
              </template>
              <li
                v-if="item.ownershipType"
                class="app-table-dropdown__list-item"
              >
                <span
                  class="app-table-dropdown__list-title app-table-dropdown__list-row"
                >
                  Вид владения
                </span>
                <p
                  class="app-table-dropdown__list-text app-table-dropdown__list-row"
                >
                  {{ $options.OWNERSHIP_TYPE[item.ownershipType] }}
                </p>
              </li>
            </ul>
            <div
              class="app-table-dropdown__row-body-default-item app-table-dropdown__empty-column"
            ></div>
          </div>
          <vehicles-sections
            isEmpty
            :sections="item.sections"
            class="vehicles-table__sections"
          ></vehicles-sections>
          <div class="app-table-dropdown__row-body-btn-block" v-if="false">
            <app-button-control
              class="app-table-dropdown__btn"
              type="white"
              @click="$emit('open-edit-vehicles', item.id)"
            >
              Изменить
            </app-button-control>
            <!-- <app-button-control
                  class="app-table-dropdown__btn"
                  type="white"
                  :route="`/vehicles/item/${item.id}`"
              >
                  Подробнее
              </app-button-control> -->
          </div>
        </div>
      </template>

      <template #portal="{ item }">
        <app-curtain-header
          title="Информация о транспорте"
          class="main-curtain-header"
        ></app-curtain-header>
        <div class="app-table-dropdown__portal main-curtain-body">
          <ul
            class="app-table-dropdown__list app-table-dropdown__row-body-default-item"
          >
            <li v-if="item.ownershipType" class="app-table-dropdown__list-item">
              <span
                class="app-table-dropdown__list-title app-table-dropdown__list-row"
              >
                Вид владения
              </span>
              <p
                class="app-table-dropdown__list-text app-table-dropdown__list-row"
              >
                {{ $options.OWNERSHIP_TYPE[item.ownershipType] }}
              </p>
            </li>
            <li class="app-table-dropdown__list-item">
              <span
                class="app-table-dropdown__list-title app-table-dropdown__list-row"
              >
                Марка авто
              </span>
              <p
                class="app-table-dropdown__list-text app-table-dropdown__list-row"
              >
                {{ item.model }}
              </p>
            </li>
            <li class="app-table-dropdown__list-item">
              <span
                class="app-table-dropdown__list-title app-table-dropdown__list-row"
              >
                Гос. номер
              </span>
              <p
                class="app-table-dropdown__list-text app-table-dropdown__list-row"
              >
                {{ item.number }}
              </p>
            </li>
            <template v-if="item.trailerModel || item.trailerNumber">
              <li class="app-table-dropdown__list-item">
                <span
                  class="app-table-dropdown__list-title app-table-dropdown__list-row"
                >
                  Модель прицепа
                </span>
                <p
                  class="app-table-dropdown__list-text app-table-dropdown__list-row"
                >
                  {{ item.trailerModel || 'н/д' }}
                </p>
              </li>
              <li class="app-table-dropdown__list-item">
                <span
                  class="app-table-dropdown__list-title app-table-dropdown__list-row"
                >
                  Номер прицепа
                </span>
                <p
                  class="app-table-dropdown__list-text app-table-dropdown__list-row"
                >
                  {{ item.trailerNumber || 'н/д' }}
                </p>
              </li>
            </template>
            <li class="app-table-dropdown__list-item">
              <span
                class="app-table-dropdown__list-title app-table-dropdown__list-row"
              >
                Полный объем, л
              </span>
              <p
                class="app-table-dropdown__list-text app-table-dropdown__list-row"
              >
                {{ getAllVolume(item.sections) }}
              </p>
            </li>
            <li class="app-table-dropdown__list-item">
              <span
                class="app-table-dropdown__list-title app-table-dropdown__list-row"
              >
                Кол-во секций
              </span>
              <p
                class="app-table-dropdown__list-text app-table-dropdown__list-row"
              >
                {{ item.sections.length }}
              </p>
            </li>
          </ul>
          <vehicles-sections
            isEmpty
            :sections="item.sections"
          ></vehicles-sections>
          <div class="app-table-dropdown__portal-footer" v-if="false">
            <app-button-control
              class="app-table-dropdown__btn"
              type="white"
              @click="$emit('open-edit-vehicles', item.id)"
            >
              Изменить
            </app-button-control>
            <!-- <app-button-control
                  class="app-table-dropdown__btn"
                  type="white"
                  :route="`/vehicles/item/${item.id}`"
                  @click="$modal.hide('main-curtain')"
              >
                  Подробнее
              </app-button-control> -->
          </div>
        </div>
      </template>
    </app-table-dropdown>
  </div>
</template>

<script>
import { OWNERSHIP_TYPE } from '@/helpers/enums/vehicles';
import { changeSort } from '@/helpers/index';

export default {
  name: 'VehiclesTable',
  inject: ['responsive'],
  components: {
    VehiclesSections: () =>
      import('@/pages/vehicles/components/VehiclesSections'),
    AppTableDropdown: () => import('@/components/common/AppTableDropdown'),
    AppButtonControl: () => import('@/components/ui/AppButtonControl'),
    AppCurtainHeader: () => import('@/components/common/AppCurtainHeader'),
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
    isAllClose: {
      type: Boolean,
    },
    sort: {
      type: Object,
      required: true,
    },
  },
  created() {
    this.$options.OWNERSHIP_TYPE = OWNERSHIP_TYPE;
  },
  methods: {
    changeSort,
    /**
     * Получить полный объем всех секций авто
     * @param {Array} sections - секции авто
     */
    getAllVolume(sections) {
      let volume = 0;

      sections.forEach((el) => {
        volume += el.volume;
      });

      return volume;
    },
  },
};
</script>

<style lang="scss">
.vehicles-table {
  &__sections {
    min-height: 104px;
    padding-bottom: 1px;
  }

  &__list-row-comma:last-of-type {
    display: none;
  }
}
</style>
